import Box from '@mui/material/Box';

import { UseAdyenGooglePay } from './hooks/use-adyen-google-pay';
import { AdyenComponentContainer } from '../../../AdyenPaymentElement/components/AdyenComponentContainer/AdyenComponentContainer';
import { AdyenThreeDSComponent } from '../../../AdyenPaymentElement/components/AdyenThreeDSContainer/AdyenThreeDSContainer';

import './styles.scss';

export function AdyenGooglePay({ onReady }: { onReady: (isAvailable: boolean) => void }) {
  const { googlePayRef, threeDSComponent } = UseAdyenGooglePay(onReady);

  if (!googlePayRef) return null;

  return (
    <>
      <Box sx={{ height: '44px' }}>
        <AdyenComponentContainer element={googlePayRef as any} hideLoader />
      </Box>
      {threeDSComponent && <AdyenThreeDSComponent threeDSComponent={threeDSComponent} />}
    </>
  );
}
